<template>
  <div class="guides-loader-tabs">
    <v-skeleton-loader
      v-for="num in numberOfTabs"
      :key="num"
      type="text"
      width="200px"
    />
  </div>
  <div :class="['guides-loader-tab-content', `${itemsPerRow}-tab-items-per-row`]">
    <div
      v-for="num in numberOfCards"
      :key="num"
      class="guides-loader-card"
    >
      <v-skeleton-loader type="text@3" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  numberOfTabs: {
    type: Number,
    default: 3,
  },
  itemsPerRow: {
    type: String,
    default: 'three',
  },
  numberOfCards: {
    type: Number,
    default: 6,
  },
});
</script>

<style scoped lang="less">
.guides-loader-tabs {
  display: flex;
  padding: 12px 24px;
  background: @white;
  width: fit-content;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  :deep(.v-skeleton-loader) {
    background: transparent;
  }
}

.guides-loader-tab-content {
  display: grid;
  gap: 24px;
  padding: 24px;
  border-radius: 10px;
  border-top-left-radius: 0;
  background: @white;

  &.three-tab-items-per-row {
    grid-template-columns: repeat(3, 1fr);
  }

  &.two-tab-items-per-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

.guides-loader-card {
  border: 1px solid @stroke-default;
  border-radius: 10px;
  padding: 24px;

  :deep(.v-skeleton-loader__text) {
    margin: 15px;
  }
}
</style>
